export async function callMsGraph(accessToken, endpoint) {
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;
  headers.append('Authorization', bearer);

  const options = {
    method: 'GET',
    headers: headers
  };

  try {
    const response = await fetch(endpoint, options);

    if (!response.ok) {
      throw new Error(
        `Error! You do not have enough rights to visit this page. \nPlease verify your subscription status or contact an administrator. Thank you.`
      );
    }

    return response.json();
  } catch (error) {
    console.error('Error calling MS Graph API:', error);
    throw error;
  }
}
